import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import Layout from "wrappers/layout";
import "./styles/style.css";

import banner1 from "../../assets/images/Banner-1-cb.jpeg";
// import banner2 from "../../assets/images/Banner-2-cb.jpeg";
import banner3 from "../../assets/images/Banner-3-cb.jpeg";

const slides = [
  { image: banner3, link: null },
  { image: banner1, link: "/multimetal-sip" },
];

function Carousel() {
  const [current, setCurrent] = useState(0);
  const autoRef = useRef(null);
  const history = useHistory();

  const goTo = (n) => setCurrent((n + slides.length) % slides.length);

  const startAuto = () => {
    autoRef.current = setInterval(
      () => setCurrent((c) => (c + 1) % slides.length),
      5000
    );
  };

  const stopAuto = () => clearInterval(autoRef.current);

  useEffect(() => {
    startAuto();
    return () => stopAuto();
  }, []);

  const handleSlideClick = (slide) => {
    if (slide.link) history.push(slide.link);
  };

  return (
    <div className="carousel-wrap" onMouseEnter={stopAuto} onMouseLeave={startAuto}>
      <div
        className="carousel-track"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {slides.map((slide, i) => (
          <div
            className="slide"
            key={i}
            onClick={() => handleSlideClick(slide)}
            style={{
              backgroundImage: `url(${slide.image})`,
              backgroundSize: "100% 100%",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              cursor: slide.link ? "pointer" : "default",
            }}
          />
        ))}
      </div>

      <button className="arr arr-l" onClick={() => goTo(current - 1)}>&#8592;</button>
      <button className="arr arr-r" onClick={() => goTo(current + 1)}>&#8594;</button>

      <div className="dots">
        {slides.map((_, i) => (
          <button
            key={i}
            className={`dot ${i === current ? "active" : ""}`}
            onClick={() => goTo(i)}
          />
        ))}
      </div>
    </div>
  );
}

/* Separator between carousel and content */
function Separator() {
  return (
    <div className="cs-separator">
      <div className="cs-separator-rule" />
      <div className="cs-separator-badge">
        <div className="cs-sep-line" />
        <div className="cs-sep-emblem">
          <div className="cs-sep-diamond" />
          <span className="cs-sep-text">Premium Gold & Silver Minted Bars</span>
          <div className="cs-sep-diamond" />
        </div>
        <div className="cs-sep-line" />
      </div>
    </div>
  );
}

/* Minimal bar SVG icon */
function BarIcon() {
  return (
    <svg className="cs-bar-svg" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect className="cs-bar-rect" x="1" y="4" width="14" height="16" rx="1" />
      <rect className="cs-bar-rect" x="3" y="1" width="10" height="5" rx="0.5" opacity="0.6" />
    </svg>
  );
}

export default function ComingSoon() {
  return (
    <Layout>
      <div className="cs-page">

        <Carousel />

        <Separator />

        <section className="cs-section">

          <div className="cs-big">
            <span className="cs-word-solid">Coming</span>
            <span className="cs-word-stroke">Soon</span>
          </div>

          <div className="cs-divider">
            <div className="cs-divider-line" />
            <span className="cs-divider-diamond">&#9670;</span>
            <div className="cs-divider-line" />
          </div>

          <div className="cs-products">
            <div className="cs-product-card cs-product-gold">
              <div className="cs-product-icon"><BarIcon /></div>
              <div className="cs-product-text">
                <h3 className="cs-product-name">Gold Bars</h3>
                <p className="cs-product-purity">999.9 Fine</p>
              </div>
            </div>

            <div className="cs-product-card cs-product-silver">
              <div className="cs-product-icon"><BarIcon /></div>
              <div className="cs-product-text">
                <h3 className="cs-product-name">Silver Bars</h3>
                <p className="cs-product-purity">999.9 Fine</p>
              </div>
            </div>
          </div>
        </section>

      </div>
    </Layout>
  );
}